import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { ThemeProvider } from '@mui/material/styles';
import preval from 'preval.macro';
import { BrowserRouter, Navigate, Route, Routes, useLocation} from 'react-router-dom';
import { Provider } from 'react-redux';

import App from './App';
import { ConfigProvider } from './app/config.ctx';
import AuthProvider from './app/auth.ctx';
import reportWebVitals from './reportWebVitals';
import { store } from './app/store'
import theme from "./app/theme";

const buildDate = preval`
let date = new Date();
let day = date.getDate().toString().padStart(2, '0');
let month = (date.getMonth() + 1).toString().padStart(2, '0'); // getMonth() is zero-indexed
let year = date.getFullYear();
let hours = date.getHours().toString().padStart(2, '0');
let minutes = date.getMinutes().toString().padStart(2, '0');
let dateFormatted = day + "." + month + "." + year + " " + hours + ":" + minutes;
module.exports = 'build date: ' + dateFormatted;
`;
console.log(buildDate);

const LanguageRedirect = () => {
  const location = useLocation();
  const { pathname, search } = location;

  // Vérifie si l'URL commence par une langue (par exemple, /en, /fr, etc.)
  const languagePattern = /^\/(en|fr|es|de|it)(\/|$)/;

  if (!languagePattern.test(pathname)) {
    // Redirige vers la même URL préfixée par /en
    return <Navigate to={`/en${pathname}${search}`} replace />;
  }

  // Si l'URL est déjà préfixée par une langue, ne fait rien
  return null;
};
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ConfigProvider>
        <AuthProvider>
          <ThemeProvider theme={theme}>
            <BrowserRouter>
              <LanguageRedirect/>
              <Routes>
                <Route path="/:lang/*" element={<App/>}/>
                <Route path="*" element={<Navigate to="/en" replace/>}/>
              </Routes>
            </BrowserRouter>
          </ThemeProvider>
        </AuthProvider>
      </ConfigProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
